import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminOrderContextOperationsResponse } from './admin-order-context-operations.response';
import { AdminOrderBuyerResponse } from './admin-order-buyer.response';
import {
  OrderStatus,
  ShippingMethodDictionaryResponse,
} from '@web/shared/module/shop';
import { AdminPaymentMethodResponse } from './admin-payment-method.response';
import { AdminOrderShipmentTrackingResponse } from './admin-order-shipment-tracking.response';
import { AdminOrderProductResponse } from './admin-order-product.response';
import { AdminOrderInvoiceResponse } from './admin-order-invoice.response';
import { DictionaryCountryResponse } from '@web/shared/module/dictionary';
import { RefundSummaryResponse } from '@web/shared/module/shop';

@jsonObject
export class AdminOrderCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly number!: string;

  @jsonMember(String)
  public readonly status!: OrderStatus;

  @jsonMember(Number)
  public readonly totalPrice!: number;

  @jsonMember(RefundSummaryResponse)
  public readonly refundSummary?: Nillable<RefundSummaryResponse>;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Boolean)
  public readonly hasError?: Nillable<boolean>;

  @jsonMember(String)
  public readonly errorMessage?: Nillable<string>;

  @jsonMember(String)
  public readonly comment?: Nillable<string>;

  @jsonMember(String)
  public readonly skinType?: Nillable<string>;

  @jsonArrayMember(String)
  public readonly variants?: Nillable<string[]>;

  @jsonMember(AdminOrderBuyerResponse)
  public readonly buyer!: AdminOrderBuyerResponse;

  @jsonArrayMember(ShippingMethodDictionaryResponse)
  public readonly shippingMethods!: ShippingMethodDictionaryResponse[];

  @jsonMember(AdminPaymentMethodResponse)
  public readonly paymentMethod!: AdminPaymentMethodResponse;

  @jsonArrayMember(DictionaryCountryResponse)
  public readonly shippingCountries!: DictionaryCountryResponse[];

  @jsonArrayMember(AdminOrderShipmentTrackingResponse)
  public readonly shipments!: AdminOrderShipmentTrackingResponse[];

  @jsonArrayMember(AdminOrderProductResponse)
  public readonly products!: AdminOrderProductResponse[];

  @jsonArrayMember(AdminOrderInvoiceResponse)
  public readonly invoices!: AdminOrderInvoiceResponse[];

  @jsonMember(AdminOrderContextOperationsResponse)
  public readonly contextOperations!: AdminOrderContextOperationsResponse;
}
